import { InquiriesItemType } from '../../api/apiConfig';

const SET_OPEN = 'inquiriesState/SET_OPEN' as const;

export interface InquiriesState {
  open: boolean;
}

export const setOpen = (payload: boolean) => ({
  type: SET_OPEN,
  payload: payload,
});

type InquiriesStateAction = {
  type: typeof SET_OPEN;
  payload: boolean;
};

const initialState: InquiriesState = {
  open: false,
};
const inquiriesStateReducer = (
  state: InquiriesState = initialState,
  action: InquiriesStateAction
): InquiriesState => {
  switch (action.type) {
    case SET_OPEN:
      return { ...state, open: action.payload };

    default:
      return state;
  }
};

export default inquiriesStateReducer;
